export const setStage = (stage) => {
  const { origin, pathname, search } = window.location
  setHistory(stage, origin, pathname, search)
}

const setHistory = (stage, origin, pathname = '/', search = '') => {
  if (search && search.includes('stage')) search = search.replace(/stage=.{1}/, `stage=${stage}`)
  else if (search && !search.includes('stage')) search = `${search}&stage=${stage}`
  else search = `?stage=${stage}`
  window.history.pushState({stage}, '', `${origin}${pathname}${search}`)
}
